import { useMutation, useQueryClient } from 'react-query';
import {
  updateCastRelationship,
  type UpdateCastRelationshipBody,
  type UpdateCastRelationshipResponse
} from '../../services/castRelationshipService';

export function useUpdateCastRelationship() {
  const queryClient = useQueryClient();
  return useMutation<
    UpdateCastRelationshipResponse,
    Error,
    { castRelationshipId: string; body: UpdateCastRelationshipBody }
  >({
    mutationFn: ({ castRelationshipId, body }) =>
      updateCastRelationship({ castRelationshipId, body }),
    onSuccess: () => {
      queryClient.invalidateQueries(['castRelationships']);
      queryClient.invalidateQueries(['castRelationship']);
      queryClient.invalidateQueries(['adaptedFictionPreviews']);
    }
  });
}
